import React from "react";
import ReactDOM from "react-dom/client";
import Spa from "./App.js";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Spa />
  </React.StrictMode>
);
